<div class="fa-stack hourglass-spin">
  <fa-icon class="fa-stack-1x fa-hourglass-start" [icon]="faHourglassStart"></fa-icon>
  <fa-icon class="fa-stack-1x fa-hourglass-half" [icon]="faHourglassHalf"></fa-icon>
  <fa-icon class="fa-stack-1x fa-hourglass-end" [icon]="faHourglassEnd"></fa-icon>
  <fa-icon class="fa-stack-1x fa-hourglass-end spin" [icon]="faHourglassEnd"></fa-icon>
</div>
